import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Paper } from '@mui/material';
import Nav from '../../component/nav/Navo';
import Footer from '../../component/footer';
import Intro from '../../component/Intro';
import loadingGif from '../CMD/loading.gif';
import './TeamComponent.css';

function TeamComponent({ mode, setmymode }) {
  const { memberId } = useParams();
  const [teamMember, setTeamMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeamMember = async () => {
      try {
        const response = await axios.get(`https://sirius.runasp.net/api/Team/${memberId}`);
        setTeamMember(response.data);
      } catch (error) {
        console.error('Error fetching team member:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTeamMember();
  }, [memberId]);

  if (loading) {
    return (
      <div style={{ margin: '50px auto', textAlign: 'center', width: '200px', height: '200px' }}>
        <img width="100%" src={loadingGif} alt="Loading..." />
      </div>
    );
  }

  const textinline = {
    headh1: "",
    spano: <span style={{ color: "#fff" }}>{teamMember.userName}</span>,
  };

  return (
    <div>
      <Nav mode={mode} setmymode={setmymode} />
      <Intro mode={mode} setmymode={setmymode} textinline={textinline} />

      <div
        className="team-container"
        style={{
          backgroundColor: mode === 'dark' ? '#333' : '#f9f9f9',
          color: mode === 'dark' ? '#fff' : '#333',
        }}
      >
        <Paper
          className="team-card"
          style={{
            backgroundColor: mode === 'dark' ? '#000' : '#ffffff',
            color: mode === 'dark' ? '#fff' : '#333',
          }}
        >
          <div className="left-sec">
            <img
              src={`https://sirius.runasp.net/${teamMember.photoPath}`}
              alt={teamMember.userName}
            />
            <h3>{teamMember.userName}</h3>
            <h4 className="position">{teamMember.position}</h4>
          </div>

          <div className="right-sec">
            <div className="section">
              <h4>Summary</h4>
              <p>{teamMember.summary}</p>
              <h4>Education</h4>
              <p>{teamMember.education.degree} — <span style={{ color: 'coral' }}>{teamMember.education.universityName}</span></p>
            </div>

            <div className="section">
              <h4>Languages</h4>
              <ul className="languages">
                {teamMember.languages.map((lang, index) => (
                  <li key={index}>{lang.languageTitle} - {lang.level}</li>
                ))}
              </ul>
            </div>

            <div className="section">
              <h4>Contacts</h4>
              <p>Email: {teamMember.contacts.email}</p>
              <p>Phone: {teamMember.contacts.phoneNumber}</p>
            </div>

            <div className="section">
              <h4>Links</h4>
              <ul className="links">
                {teamMember.links.map((link, index) => (
                  <li key={index}>
                    <a href={link.linkAddress} target="_blank" rel="noopener noreferrer">
                      {link.typeName}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="section">
              <h4>Skills</h4>
              <ul id="uloo" className="skills">
                {teamMember.skills.map((skill, index) => (
                  <li key={index} style={{ breakInside: 'avoid', margin: '5px' }}>
                    {skill.skillTitle}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Paper>
      </div>

      <Footer />
    </div>
  );
}

export default TeamComponent;
